/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const QuarantinedRegistrationParser = 
/* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['email', codecString],
    ['username', codecString],
    ['name', codecString],
    ['createdAt', parsers.moment, 'created_at'],
]);
export class QuarantinedRegistration extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return QuarantinedRegistrationParser.decode(input).map(res => new QuarantinedRegistration(res));
    }
    static unsafeDecode(input) {
        return QuarantinedRegistration.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return QuarantinedRegistrationParser.encode(data);
    }
    static schema() {
        return QuarantinedRegistrationParser.schema();
    }
}
